import { css } from "styled-components/macro";
import { shade, rgba } from "polished";
import { colors, boxShadow, transition } from "shared/styles/constants";

const defaultHover = (bgColor: string, hoverColor?: string) => css`
  transition: background-color ${transition.default},
    box-shadow ${transition.default}, border-color ${transition.default},
    transform ${transition.default}, opacity ${transition.default};

  &:hover {
    &:not(:disabled) {
      background-color: ${hoverColor ? hoverColor : shade(0.2, bgColor)};
      box-shadow: ${boxShadow.m};
    }
  }
`;

const focusStyle = css`
  transition: background-color ${transition.default},
    box-shadow ${transition.default}, border-color ${transition.default};

  outline: none;
  box-shadow: 0 0 0 3px ${rgba(colors.blue, 0.5)} !important; // overrule hover style
`;

const defaultFocus = css`
  transition: background-color ${transition.default},
    box-shadow ${transition.default}, border-color ${transition.default};

  &:focus-within {
    ${focusStyle}
  }
`;

export const hoverFocus = {
  defaultHover,
  focusStyle,
  defaultFocus,
};
